import React from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {setWizardNodeInputFocused, updateWizardList} from "../wizardActions";
import {wizardGroupInterface, wizardItemInterface} from "../WizardItem/wizardItemInterface";
import TextInput from "../../Generic/textInput";

const WizardNodeLabel = (props) => {

  const {wizardActiveItem, wizardGroup, updateWizardList, intl, setWizardNodeInputFocused} = props;

  // const areSameSiblingGroups = checkForSameSiblingsGroups(siblingGroups);
  // if (!areSameSiblingGroups) {
  //   return null
  // }

  const updateWizardGroupLabel = (newValue) => {
    wizardActiveItem.wizardGroups = wizardActiveItem.wizardGroups.map(wizGroup => {
      if (wizGroup.id === wizardGroup.id) {
        wizardGroup.label = newValue;
      }
      return wizGroup
    })
    updateWizardList(wizardActiveItem);
  }

  return (
    <div className={"wizard-group__label" + (!wizardGroup.label ? " wizard-group__label--empty" : "")}>
      <TextInput className={`discount-name ui-input ui-input--gray4 ui-input--gray4--small`}
                 placeholder={intl.formatMessage({ id: "wizard.group.label" })}
                 onFocus={() => setWizardNodeInputFocused(true)}
                 onBlur={() => setWizardNodeInputFocused(false)}
                 onChange={updateWizardGroupLabel}
                 maxLength={30}
                 value={wizardGroup.label || ""} />
    </div>
  )
};

WizardNodeLabel.propTypes = {
  wizardActiveItem: PropTypes.shape(wizardItemInterface).isRequired,
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
}

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  updateWizardList,
  setWizardNodeInputFocused,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardNodeLabel)
)
